
import MenuItemType from './MenuItemType'

export default {
  enabled: item => MenuItemType.enabled(item.type) && ! item.usesWeight,
}
